/* eslint-disable import/prefer-default-export */
import _set from 'lodash/set';
import { EDIT_MODE_SLIDE_EXTRA_HEIGHT, EDIT_MODE_SLIDE_WIDTH, MOBILE_SLIDEBAR_HEIGHT } from '@src/js/constant';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { LinkMode } from './canvas-constants';

export const isEditable = props => (typeof (props.editable) === 'undefined' ? true : props.editable);

export const isMultiplyElementSelected = () => {
    const length = getAppServices().viewableServiceLayer.selectionService
        .selectedElements.selectedArray?.length;
    return length && length > 1;
};

export const clickElementJudge = (dom, curDom) => (curDom.id
        && (curDom.id === 'link-float-container-id'
            || curDom === dom
            || curDom.id === 'selected-element-outer'));

export const isOnNoteArea = (rect) => {
    if (!rect) return true;
    const noteArea: any = document.getElementById('noteArea');
    const noteAreaRect = noteArea?.getBoundingClientRect();
    return noteAreaRect?.top < rect.top;
};

export const getMode = (data) => {
    if (!data) return LinkMode.NOLINK;
    return (data?.addon?.displayMode === AddonMode.IFRAME
        ? LinkMode.AlWAYSHOW
        : LinkMode.ENTERLEAVE);
};

/**
* 插入形状时生成默认文本属性
*/
export const createDefaultTextStyle = () => {
    const extraInfo = {};
    _set(extraInfo, 'textBodyStyle.wrapperStyle.alignItems', 'center');
    _set(extraInfo, 'paragraphList[0].paragraphProps.textAlign', 'center');
    _set(extraInfo, 'paragraphList[0].paragraphProps.raw-textAlign', true);
    _set(extraInfo, 'paragraphList[0].textRuns',  [{ text: '', styles: {} }]);

    return extraInfo;
};

export const setModeLeftOffsetFrameWithShiftKey = (params: {
    shiftKey: boolean | undefined;
    mode: string;
    offsetFrame: any;
    scale: number;
}) => {
    const { shiftKey, mode, offsetFrame, scale } = params;
    if (!shiftKey) {
        return;
    }

    switch (mode) {
        case MODES.TOP_LEFT:
            offsetFrame.height = offsetFrame.width * scale;
            offsetFrame.top = offsetFrame.left * scale;
            break;
        case MODES.TOP_RIGHT:
            offsetFrame.height = offsetFrame.width * scale;
            offsetFrame.top = -offsetFrame.height;
            break;
        case MODES.BOTTOM_LEFT:
            offsetFrame.height = offsetFrame.width * scale;
            break;
        case MODES.BOTTOM_RIGHT:
            offsetFrame.height = offsetFrame.width * scale;
            break;
        default:
            break;
    }
};

export const setModeTopOffsetFrameWithShiftKey = (params: {
    shiftKey: boolean | undefined;
    mode: string;
    offsetFrame: any;
    scale: number;
}) => {
    const { shiftKey, mode, offsetFrame, scale } = params;
    if (!shiftKey) {
        return;
    }

    switch (mode) {
        case MODES.TOP_LEFT:
            offsetFrame.width = offsetFrame.height / scale;
            offsetFrame.left = offsetFrame.top / scale;
            break;
        case MODES.TOP_RIGHT:
            offsetFrame.width = offsetFrame.height / scale;
            break;
        case MODES.BOTTOM_LEFT:
            offsetFrame.width = offsetFrame.height / scale;
            offsetFrame.left = -offsetFrame.width;
            break;
        case MODES.BOTTOM_RIGHT:
            offsetFrame.width = offsetFrame.height / scale;
            break;
        default:
            break;
    }
};

export const getSlideListHeight = () => {
    if (!getAppServices()?.getUiDataService()?.presentation?.props) {
        return MOBILE_SLIDEBAR_HEIGHT;
    }
    const { slideWidth, slideHeight } = getAppServices().getUiDataService().presentation.props;
    // 这里加 33.75 是为了保证幻灯片比例为 16 : 9 时，list 高度为 90，对齐历史逻辑
    return (EDIT_MODE_SLIDE_WIDTH * (slideHeight / slideWidth)) + EDIT_MODE_SLIDE_EXTRA_HEIGHT;
};

function getAppServices(): IEditorAppServices {
    return AppServiceProvider.getInstance().getAppServices() as
        IEditorAppServices;
}
